import React, { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
  MenuItem,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItemButton,
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import logo_name1 from '../Assets/Logo/law_college_logo.svg'
import FounderImage from '../Assets/Images/Kaka-venkataswamy-2-768x538 1.png'
import LawCollegeCertifications from '../Assets/Logo/LawCollege_certified.png'
import Law_cat_code from '../Assets/Logo/Law_cet_code.png'
import PhoneIcon from '@mui/icons-material/Phone'
import '../Styles/Header.css'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const navItems = [
  {
    id: 1,
    title: 'Home',
    pathname: '/home',
    disabled: false,
  },
  {
    id: 2,
    title: 'About',
    pathname: '/about',
    subnav_flag: true,
    disabled: false,
    subnav: [
      {
        title: 'About Us',
        pathname: '/aboutus',
        disabled: false,
      },
      {
        title: 'Contact Us',
        pathname: '/contactus',
        disabled: false,
      },
      {
        title: 'InfraStructure',
        pathname: '/infrastructure',
        disabled: false,
      },
      {
        title: 'Institutional Policy',
        pathname: '/institutionalpolicy',
        disabled: false,
      },
      {
        title: 'Best Practices',
        pathname: '/bestpracticepage',
        disabled: false,
      },
      {
        title: 'Distinctive Feature',
        pathname: '/distinctivefeaturepage',
        disabled: false,
      },
      {
        title: 'NEP, IKS & IDP',
        pathname: '/nepiksidppage',
        disabled: false,
      },
    ],
  },
  {
    id: 3,
    title: 'Academic',
    pathname: '/academics',
    subnav_flag: true,
    subnav: [
      {
        title: 'Courses',
        subnav_flag: true,
        disabled: false,
        subnav: {
          LLB: [
            {
              title: 'LLB-3YDC',
              pathname: '/courseoffering/llb/llb-3ydc',
              disabled: false,
            },
            {
              title: 'LLB-5YDC',
              pathname: '/courseoffering/llb/llb-5ydc',
              disabled: false,
            },
          ],
          LLM: [
            {
              title: 'Labour Law',
              pathname: '/courseoffering/llm/labour-law',
              disabled: false,
            },
            {
              title: 'Constitutional Law',
              pathname: '/courseoffering/llm/constitutional-law',
              disabled: false,
            },
          ],
        },
      },
      {
        title: 'Faculty',
        pathname: '/faculty',
        disabled: false,
      },
      {
        title: 'Notes',
        pathname: '/notes',
        disabled: false,
      },
      {
        title: "Po's & Co's - Manual",
        pathname: '/co&po',
        disabled: false,
      },
      {
        title: 'Library',
        pathname: '/library',
        disabled: false,
      },
    ],
  },
  {
    id: 5,
    title: 'IQAC',
    pathname: '/iqac',
    subnav_flag: true,
    subnav: [
      {
        title: 'About IQAC',
        pathname: '/aboutIQAC',
        disabled: false,
      },
      {
        title: 'Quality Policy',
        pathname: '/Qualitypolicy',
        disabled: false,
      },
      {
        title: 'IQAC Objectives',
        pathname: '/IQACObjective',
        disabled: false,
      },
      {
        title: 'Parameters of IQAC',
        pathname: '/IQACParameter',
        disabled: false,
      },
      {
        title: 'Working Committee',
        pathname: '/workingcommitee',
        disabled: false,
      },
      {
        title: 'Mandatory Document',
        pathname: '/mandatorydoc',
        disabled: false,
      },
      {
        title: 'IQAC Meetings',
        pathname: '/iqacmeetings',
        disabled: false,
      },
      {
        title: 'IQAC Documents',
        pathname: '/IQACDocuments',
        disabled: false,
      },
    ],
  },
  {
    id: 6,
    title: 'Activities',
    pathname: '/activity',
    disabled: false,
  },
  {
    id: 6,
    title: 'NIRF',
    pathname: '/nirf',
    disabled: false,
  },
  {
    id: 7,
    title: 'NAAC',
    pathname: '/naac',
    disabled: false,
  },
  {
    id: 8,
    title: 'Feedback',
    pathname: '/Feedback',
    disabled: false,
  },
  {
    id: 11,
    title: 'ALC News Letter',
    pathname: '/alcnewsletter',
    disabled: false,
  },
  {
    id: 12,
    title: 'Committees',
    subnav_flag: true,
    subnav: [
      {
        title: 'Statutory committees',
        pathname: '/statutorycommittees',
        disabled: false,
      },
      {
        title: 'Non Statutory committees',
        pathname: '/nonstatutorycommittees',
        disabled: false,
      },
    ],
  },
]
const Header = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()
  const [mobileOpen, setMobileOpen] = useState(false)
  const [expanded, setExpanded] = useState(null)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')) // Below 600px
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'))
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const [activeNavItem, setActiveNavItem] = useState(null)
  const [activeSubNav, setActiveSubNav] = useState(null)
  const [isFixed, setIsFixed] = useState(false)
  const headerRef = useRef(null)

  const handleExpand = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null)
  }
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState)
  }
  useEffect(() => {
    const handleScroll = () => {
      if (!headerRef.current) return

      const headerTop =
        headerRef.current.offsetTop + headerRef.current.offsetHeight
      const scrollTop = window.scrollY

      // Check if scrolled past the header
      setIsFixed(scrollTop > headerTop)
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])
  const isMenuItemActive = (item) => {
    if (item.subnav_flag && item.subnav) {
      // For items with subnav, check if any subitem matches exactly
      return item.subnav.some((subItem) => {
        if (subItem.subnav_flag && subItem.subnav) {
          // Handle nested subnav (like Courses)
          return Object.values(subItem.subnav).some((courseType) =>
            courseType.some((course) => location.pathname === course.pathname)
          )
        }
        return location.pathname === subItem.pathname
      })
    }
    // For regular items, check exact match
    return location.pathname === item.pathname
  }
  useEffect(() => {
    // Reset navigation states when route changes
    setActiveNavItem(null)
    setActiveSubNav(null)
  }, [location.pathname])
  const handleNavigation = (item, subItem = null, callback) => {
    if (subItem) {
      const selected_data = { College: item, CourseOffered: subItem }
      navigate(subItem.pathname, { state: { College_details: selected_data } })
      setActiveSubNav(subItem.title === activeSubNav ? null : subItem.title)
    } else if (item.subnav_flag) {
      setActiveNavItem(item.title === activeNavItem ? null : item.title)
    } else {
      navigate(item.pathname)
    }
  }
  const renderSubMenu = (subnav, depth = 0) => (
    <Box
      sx={{
        position: 'absolute',
        top: '100%',
        left: depth > 0 ? '100%' : 0,
        backgroundColor: 'white',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        borderRadius: 1,
        zIndex: 1000,
        padding: '8px 0',
        minWidth: '200px',
      }}
      onMouseEnter={() => setActiveSubNav(subnav.id)}
      onMouseLeave={() => setActiveSubNav(null)}
    >
      {subnav.map((subItem, i) => (
        <Box key={subItem.title} sx={{ position: 'relative' }}>
          <MenuItem
            onMouseEnter={() => {
              if (subItem.subnav_flag) {
                setActiveSubNav(subItem.title) // Show submenu on hover
              }
            }}
            onClick={(e) => {
              // Prevent navigation if it's the Courses item
              if (subItem.title === 'Courses') {
                e.preventDefault()
                e.stopPropagation()
              } else {
                handleNavigation(null, subItem)
              }
            }}
            disabled={subItem.disabled}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',

              '&:hover': {
                backgroundColor: '#f2f2f2',
                cursor: 'pointer',
                zoom: 1.05,
              },
            }}
            key={subItem.pathname}
          >
            {subItem.title}

            {subItem.subnav_flag && (
              <KeyboardArrowDownIcon
                fontSize="medium"
                style={{
                  transform:
                    activeSubNav === subItem.title
                      ? 'rotate(-90deg)'
                      : 'rotate(0deg)',
                  transition: 'transform 0.2s ease-in-out',
                }}
              />
            )}
          </MenuItem>
          {/* Show nested Courses menu on hover */}
          {subItem.subnav_flag && activeSubNav === subItem.title && (
            <Box
              sx={{
                position: 'absolute',
                left: '100%',
                top: 0,
                width: '220px',
                backgroundColor: 'white',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                borderRadius: 1,
                zIndex: 1001,
              }}
              onMouseEnter={() => setActiveSubNav(subItem.title)} // Keep open while hovering
              onMouseLeave={() => setActiveSubNav(null)} // Close when mouse leaves
            >
              {Object.entries(subItem.subnav).map(([courseType, courses]) => (
                <Box key={courseType} sx={{ mb: 1 }}>
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    sx={{ px: 2, py: 1 }}
                  >
                    {courseType}
                  </Typography>
                  <Divider
                    sx={{
                      mb: 1,
                      bgcolor: '#494798',
                    }}
                  />
                  {courses.map((course) => (
                    <MenuItem
                      key={course.pathname}
                      onClick={() => handleNavigation(null, course)}
                      sx={{
                        fontSize: '0.875rem',
                        '&:hover': {
                          backgroundColor: '#f2f2f2',
                          zoom: 1.05,
                        },
                      }}
                    >
                      {course.title}
                    </MenuItem>
                  ))}
                </Box>
              ))}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  )
  // const rendernestedMenu = (subnav, depth = 0) => {
  //   return (
  //     <Box
  //       sx={{
  //         width: '100%', // Take full width
  //         backgroundColor: 'white',
  //         boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
  //         borderRadius: 2,
  //         zIndex: 1000,
  //         padding: '12px 0',
  //         minWidth: '220px',
  //         maxWidth: '100%', // Ensure it doesn't overflow
  //         maxHeight: '400px',
  //         overflowY: 'auto',
  //       }}
  //     >
  //       {Object.keys(subnav).map((courseType) => (
  //         <Accordion key={courseType} defaultExpanded={depth === 0}>
  //           <AccordionSummary
  //             expandIcon={<ExpandMoreIcon />}
  //             aria-controls={`${courseType}-content`}
  //             id={`${courseType}-header`}
  //           >
  //             <Typography
  //               variant="body2"
  //               sx={{
  //                 fontWeight: '600',
  //                 color: 'Black',
  //                 fontSize: '1rem',
  //               }}
  //             >
  //               {courseType}
  //             </Typography>
  //           </AccordionSummary>
  //           <AccordionDetails>
  //             {Object.values(subnav[courseType]).map((subItem, i) => (
  //               <Box key={subItem.pathname} sx={{ position: 'relative' }}>
  //                 <MenuItem
  //                   onClick={() => handleNavigation(null, subItem)}
  //                   disabled={subItem.disabled}
  //                   sx={{
  //                     display: 'flex',
  //                     padding: '8px 16px',
  //                     fontSize: 'small',
  //                     '&:hover': {
  //                       backgroundColor: '#f2f2f2',
  //                       cursor: 'pointer',
  //                       zoom: 1.1,
  //                     },
  //                     '&.Mui-disabled': {
  //                       backgroundColor: '#f5f5f5',
  //                       color: '#b0b0b0',
  //                     },
  //                   }}
  //                 >
  //                   {subItem.title}
  //                   <KeyboardArrowRightIcon fontSize="small" />
  //                 </MenuItem>
  //                 {subItem.subnav &&
  //                   rendernestedMenu(subItem.subnav, depth + 1)}
  //               </Box>
  //             ))}
  //           </AccordionDetails>
  //         </Accordion>
  //       ))}
  //     </Box>
  //   )
  // }

  const renderNavItems = () => {
    return navItems.map((item) => (
      <Box
        key={item.id}
        sx={{ position: 'relative' }}
        onMouseEnter={() => {
          if (item.subnav_flag) {
            setActiveNavItem(item.id)
          } else {
            setActiveNavItem(null)
            setActiveSubNav(null)
          }
        }}
        onMouseLeave={() => {
          setActiveNavItem(null)
          setActiveSubNav(null)
        }}
      >
        <Button
          onClick={() => handleNavigation(item)}
          sx={{
            color: 'white',
            textTransform: 'none',
            padding: '10px',
            borderBottom: isMenuItemActive(item)
              ? '4px solid #F15215'
              : '4px solid transparent',
          }}
        >
          {item.title}
          {item.subnav_flag && (
            <KeyboardArrowDownIcon
              sx={{
                marginLeft: 1,
                transform:
                  activeNavItem === item.id ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s ease-in-out',
              }}
            />
          )}
        </Button>
        {item.subnav_flag &&
          activeNavItem === item.id &&
          renderSubMenu(item.subnav)}
      </Box>
    ))
  }

  return (
    <section>
      <Box>
        <CssBaseline />
        <AppBar
          sx={{
            backgroundColor: '#F15215',
            position: 'relative',
            height: isMobile ? '48px' : '38px', // Changed from maxHeight to height for consistency
            width: '100%',
            overflow: 'hidden', // Prevents any content from overflowing
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' }, // Stack on small screens, row on larger
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: { xs: '6px 10px', sm: '6px 20px' },
              marginX: { xs: '0.5rem', sm: '2rem', md: '1rem' },
              width: '100%', // Ensures full width
            }}
          >
            {/* Phone Numbers Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: { xs: '4px', sm: '8px' },
                justifyContent: { xs: 'center', sm: 'flex-start' }, // Center on small screens
                textAlign: 'center', // Helps keep phone numbers aligned
              }}
            >
              <PhoneIcon sx={{ fontSize: { xs: 16, sm: 20, md: 22 } }} />{' '}
              {/* Smaller icon */}
              <Typography
                variant="body2"
                className="phone-numbers"
                sx={{
                  fontSize: { xs: '10px', sm: '12px', md: '14px' }, // Adjust font size
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: { xs: 'center', sm: 'flex-start' },
                  gap: '5px',
                }}
              >
                <a href="tel:040-27670675" className="phone-link">
                  040 – 2767 06 75
                </a>
                /
                <a href="tel:+919100221282" className="phone-link">
                  +91 9100221282
                </a>
                /
                <a href="tel:+918331041175" className="phone-link">
                  +91 8331041175
                </a>
              </Typography>
            </Box>

            {/* Law CET Code Image Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: { xs: 'center', sm: 'flex-end' },
                width: { xs: '100%', sm: 'auto' },
                maxWidth: { xs: '120px', sm: '200px' }, // Control the maximum width
                height: 'auto', // Maintain aspect ratio
              }}
            >
              <img
                src={Law_cat_code}
                alt="Law CET Code"
                loading="lazy"
                placeholder="blur"
                style={{
                  width: '100%', // Adjust width dynamically
                  height: 'auto',
                  objectFit: 'contain', // Ensures the image fits within the container
                }}
              />
            </Box>
          </Box>
        </AppBar>
        <AppBar
          sx={{
            backgroundColor: 'white',
            position: 'relative',
            height: '100px', // Set height explicitly
            maxWidth: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              paddingX: { xs: '16px', sm: '40px' },
              height: '100%', // Ensure it takes full height
            }}
          >
            {/* Left Section: Founder Image + College Logo */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                height: '100%', // Match AppBar height
              }}
            >
              {/* Founder Image */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%', // Match AppBar height
                  maxWidth: '200px',
                }}
              >
                <img
                  src={FounderImage}
                  alt="Founder"
                  loading="lazy"
                  placeholder="blur"
                  style={{
                    height: '100%',
                    width: 'auto',
                    objectFit: 'contain',
                  }}
                />
              </Box>

              {/* College Logo */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start', // Align to the left
                  height: '100%',
                  marginLeft: '16px', // Space between Founder Image and Logo
                }}
              >
                <img
                  src={logo_name1}
                  alt="College Logo"
                  loading="lazy"
                  placeholder="blur"
                  style={{
                    height: '80%', // Adjust to fit within AppBar
                    maxHeight: '100px',
                    width: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Box>
            </Box>

            {/* Right Section: Certifications (Only on larger screens) */}
            {!isSmallScreen && !isTablet && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <img
                  src={LawCollegeCertifications}
                  alt="College Certifications"
                  loading="lazy"
                  placeholder="blur"
                  style={{
                    height: '80%',
                    maxHeight: '100px',
                    objectFit: 'contain',
                  }}
                />
              </Box>
            )}
          </Box>
        </AppBar>
        {/* Third AppBar (Navigation) */}
        <Box
          className="third-app-bar"
          ref={headerRef}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: '#494798',
            position: isFixed ? 'fixed' : 'relative',
            top: isFixed ? 0 : 'unset',
            left: 0,
            right: 0,
            zIndex: 1100,
            padding: { xs: '0 8px', sm: '0 16px', md: '0 24px' }, // Add this line to prevent horizontal scroll
            boxSizing: 'border-box',
            alignItems: isMobile ? 'flex-end' : 'center',
          }}
        >
          {/* Left Side */}
          <Box display="flex" justifyContent="end">
            {isMobile || isTablet ? (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerToggle}
              >
                <MenuIcon />
              </IconButton>
            ) : (
              renderNavItems()
            )}
          </Box>
          {/* Drawer for Mobile & Tablet */}
          {/* Drawer for Mobile & Tablet */}
          <Drawer
            variant="temporary"
            anchor="right"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: 'block', sm: 'block', md: 'none' },
              '& .MuiDrawer-paper': {
                boxSizing: 'border-box',
                width: '60vw',
                padding: '8px',
              },
            }}
          >
            <Button
              onClick={handleDrawerToggle}
              sx={{ fontWeight: 'bold', justifyContent: 'start' }}
            >
              <CloseIcon sx={{ transition: 'transform 0.3s ease' }} />
            </Button>

            <Divider sx={{ bgcolor: 'primary.contrastText' }} />

            <List>
              {navItems.map((item, index) => {
                const isActive = location.pathname === item.pathname

                const renderNestedItems = (
                  data,
                  level = 0,
                  parentItem = null
                ) => {
                  if (Array.isArray(data)) {
                    return data.map((subItem, subIndex) => (
                      <Box key={subIndex} sx={{ pl: level * 2 }}>
                        {subItem.subnav_flag ? (
                          <Accordion
                            sx={{
                              boxShadow: 'none',
                              backgroundColor: 'transparent',
                              '&:before': { display: 'none' },
                            }}
                          >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography
                                sx={{
                                  color: 'black',
                                  fontWeight: level === 0 ? 'bold' : 'normal',
                                }}
                              >
                                {subItem.title}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ p: 0 }}>
                              {renderNestedItems(
                                subItem.subnav,
                                level + 1,
                                subItem
                              )}
                            </AccordionDetails>
                          </Accordion>
                        ) : (
                          <ListItemButton
                            onClick={() => {
                              const selected_data = {
                                College: parentItem,
                                CourseOffered: subItem,
                              }
                              navigate(subItem.pathname, {
                                state: { College_details: selected_data },
                              })
                              setMobileOpen(false)
                            }}
                            sx={{
                              background:
                                location.pathname === subItem.pathname
                                  ? '#E0E0E0'
                                  : 'transparent',
                              color:
                                location.pathname === subItem.pathname
                                  ? '#F15215'
                                  : 'black',
                            }}
                          >
                            <ListItemText primary={subItem.title} />
                          </ListItemButton>
                        )}
                      </Box>
                    ))
                  } else if (typeof data === 'object' && !Array.isArray(data)) {
                    return Object.entries(data).map(([key, value], i) => (
                      <Accordion
                        key={i}
                        sx={{
                          boxShadow: 'none',
                          backgroundColor: 'transparent',
                          '&:before': { display: 'none' },
                        }}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography
                            sx={{ color: 'black', fontWeight: 'normal' }}
                          >
                            {key}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0 }}>
                          {value.map((course, j) => {
                            // Create URL-friendly ID
                            const courseId = course.title
                              .toLowerCase()
                              .replace(/\s+/g, '-')
                            const courseType = key.toLowerCase() // 'llb' or 'llm'

                            return (
                              <ListItemButton
                                key={j}
                                onClick={() => {
                                  const selected_data = {
                                    College: {
                                      title: 'Courses',
                                      pathname: '/academics/courses',
                                    },
                                    CourseOffered: {
                                      ...course,
                                      pathname: `/courseoffering/${courseType}/${courseId}`,
                                    },
                                  }

                                  // Navigate using both URL and state
                                  navigate(
                                    `/courseoffering/${courseType}/${courseId}`,
                                    {
                                      state: { College_details: selected_data },
                                    }
                                  )
                                  setMobileOpen(false)
                                }}
                                sx={{
                                  pl: 4,
                                  background:
                                    location.pathname ===
                                    `/courseoffering/${courseType}/${courseId}`
                                      ? '#E0E0E0'
                                      : 'transparent',
                                  color:
                                    location.pathname ===
                                    `/courseoffering/${courseType}/${courseId}`
                                      ? '#F15215'
                                      : 'black',
                                }}
                              >
                                <ListItemText primary={course.title} />
                              </ListItemButton>
                            )
                          })}
                        </AccordionDetails>
                      </Accordion>
                    ))
                  }
                  return null
                }

                return (
                  <div key={index}>
                    {item.subnav_flag ? (
                      <Accordion
                        expanded={expanded === item.title}
                        onChange={handleExpand(item.title)}
                        sx={{
                          boxShadow: 'none',
                          backgroundColor: 'transparent',
                          '&:before': { display: 'none' },
                        }}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography
                            sx={{
                              color: isActive ? '#F15215' : 'black',
                              fontWeight: 'bold',
                            }}
                          >
                            {item.title}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 0 }}>
                          {renderNestedItems(item.subnav, 1, item)}
                        </AccordionDetails>
                      </Accordion>
                    ) : (
                      <ListItem disablePadding>
                        <ListItemButton
                          onClick={() => {
                            navigate(item.pathname)
                            setMobileOpen(false)
                          }}
                          sx={{
                            background: isActive ? '#E0E0E0' : 'transparent',
                            color: isActive ? '#F15215' : 'black',
                          }}
                        >
                          <ListItemText
                            primary={item.title}
                            primaryTypographyProps={{ fontWeight: 'bold' }}
                          />
                        </ListItemButton>
                      </ListItem>
                    )}
                  </div>
                )
              })}
            </List>
          </Drawer>
        </Box>
      </Box>
    </section>
  )
}
export default Header
